import { useQuery } from 'react-query';
import { format } from 'date-fns';
import { CUSTOMERS_QUERY_KEY } from '../../constants/query';
import CustomerService from '../../services/customer.service';

const useFetchCustomers = ({ search, limit, page } = {}) =>
  useQuery(!search ? CUSTOMERS_QUERY_KEY : [CUSTOMERS_QUERY_KEY, search], async () => {
    const response = await CustomerService.getCustomers({
      search,
      limit,
      page,
    });

    if (!response?.customers?.length || !response?.count) {
      return {
        pages: [
          {
            customers: [],
            count: 0,
            totalCount: response.totalCount,
          },
        ],
      };
    }

    const customers = response.customers.map(customer => ({
      ...customer,
      createdAt: format(new Date(customer.createdAt), 'yyyy-MM-dd'),
      updatedAt: format(new Date(customer.updatedAt), 'yyyy-MM-dd'),
    }));

    return {
      pages: [
        {
          customers,
          count: response.count,
          totalCount: response.totalCount,
        },
      ],
    };
  });

export default useFetchCustomers;
